// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plansScreen_container__ljbWx {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    height: 100%;
}

/* Logo Styling */
.plansScreen_logoContainer__rBIPW {
    position: relative;
    width: 60px;
    height: 60px;
    overflow: hidden;
    flex-shrink: 0;
}

.plansScreen_logo__9zZus {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* Content Section */
.plansScreen_contentSection__lwbV- {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    flex-shrink: 0;
}

.plansScreen_title__wCWEn {
    font-family: 'Noto Sans', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #F3F4F6;
    margin: 0;
    width: 100%;
}

/* Plans Container */
.plansScreen_plansContainer__LR1H0 {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
}

/* Price Card with gradient border */
.plansScreen_priceCard__cFsj7 {
    position: relative;
    padding: 16px;
    width: 100%;
    box-sizing: border-box;
    flex-shrink: 0;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: var(--corner-radius-radius-12-41-72-wxh, 16px);
    /* Create gradient border effect - Gold to Pink/Purple */
    background: 
        linear-gradient(109deg, #3C2929 0%, #161B20 100%) padding-box,
        linear-gradient(90deg, #FFD976 0%, #FD82F8 100%) border-box;
    border: 1px solid transparent;
}

.plansScreen_priceCard__cFsj7:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(253, 130, 248, 0.3);
}

.plansScreen_priceCard__cFsj7:active {
    transform: translateY(0);
}

.plansScreen_priceCardSelected__0gY4P {
    background: 
        linear-gradient(109deg, #3C2929 0%, #161B20 100%) padding-box,
        linear-gradient(90deg, #FFD976 0%, #FD82F8 100%) border-box;
    border: 2px solid transparent;
    box-shadow: 0 0 20px rgba(253, 130, 248, 0.5);
}

.plansScreen_priceCardContent__2QkCX {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

/* Price Row */
.plansScreen_priceRow__pH-lX {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.plansScreen_priceGroup__0paUl {
    display: flex;
    align-items: center;
    gap: 6px;
}

.plansScreen_currentPrice__zsKwn {
    font-family: 'Noto Sans', sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    background: var(--ui-gradient-studio-brand, linear-gradient(270deg, #FD82F8 0%, #FFD976 100%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.plansScreen_originalPrice__Vq2l1 {
    font-family: 'Noto Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #9396A3;
    text-decoration: line-through;
    text-decoration-skip-ink: none;
}

.plansScreen_perDayBadge__GFRi1 {
    background-color: #0D0E11;
    border-radius: 4px;
    padding: 4px 6px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.plansScreen_perDayText__1yvRq {
    font-family: 'Noto Sans', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    background: linear-gradient(180deg, #D5982F 0%, #FDF59A 50%, #D5982F 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    white-space: nowrap;
}

/* Duration Row */
.plansScreen_durationRow__MDdGR {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.plansScreen_durationText__WDNJu {
    font-family: 'Noto Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #F3F4F6;
    white-space: nowrap;
}

.plansScreen_badgeIconWrapper__8Onra {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

.plansScreen_badgeIcon__CYz-0 {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* Timeline Section */
.plansScreen_timelineSection__v2NoZ {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    padding: 0 20px;
    border-radius: 16px;
    width: 100%;
    box-sizing: border-box;
    flex-shrink: 0;
}

.plansScreen_timelineContent__IzVsQ {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    width: 100%;
    flex-shrink: 0;
}

/* Vertical Line SVG Container */
.plansScreen_verticalLine__6do8F {
    position: relative;
    width: 7px;
    height: 52px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.plansScreen_verticalLine__6do8F svg {
    display: block;
    width: 100%;
    height: 100%;
}

/* Dates Container */
.plansScreen_datesContainer__NsN8h {
    display: flex;
    flex: 1 1;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
    flex-shrink: 0;
}

.plansScreen_dateRow__SB9cc {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    font-family: 'Noto Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
}

.plansScreen_dateLabel__QpaxS {
    color: #9396A3;
    white-space: nowrap;
}

.plansScreen_dateValue__dT5N3 {
    color: #F3F4F6;
    white-space: nowrap;
}

/* Separator */
.plansScreen_separator__4f4RJ {
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, 
        rgba(255, 255, 255, 0) 0%, 
        rgba(255, 255, 255, 0.2) 50%, 
        rgba(255, 255, 255, 0) 100%
    );
    flex-shrink: 0;
}

/* Footer Text */
.plansScreen_footerText__S6xUr {
    font-family: 'Noto Sans', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #9396A3;
    text-align: center;
    width: 100%;
    margin: 0;
    flex-shrink: 0;
    white-space: pre-wrap;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .plansScreen_timelineSection__v2NoZ {
        padding: 0 16px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/pwatv/PlansScreen/plansScreen.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,6DAA6D;IAC7D,wDAAwD;IACxD;;mEAE+D;IAC/D,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;;mEAE+D;IAC/D,6BAA6B;IAC7B,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA,cAAc;AACd;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,8FAA8F;IAC9F,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0EAA0E;IAC1E,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,WAAW;IACX,cAAc;AAClB;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,SAAO;IACP,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,WAAW;IACX,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,WAAW;IACX,WAAW;IACX;;;;KAIC;IACD,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,cAAc;IACd,qBAAqB;AACzB;;AAEA,2BAA2B;AAC3B;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    width: 100%;\n    height: 100%;\n}\n\n/* Logo Styling */\n.logoContainer {\n    position: relative;\n    width: 60px;\n    height: 60px;\n    overflow: hidden;\n    flex-shrink: 0;\n}\n\n.logo {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n/* Content Section */\n.contentSection {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n    flex-shrink: 0;\n}\n\n.title {\n    font-family: 'Noto Sans', sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 20px;\n    color: #F3F4F6;\n    margin: 0;\n    width: 100%;\n}\n\n/* Plans Container */\n.plansContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n}\n\n/* Price Card with gradient border */\n.priceCard {\n    position: relative;\n    padding: 16px;\n    width: 100%;\n    box-sizing: border-box;\n    flex-shrink: 0;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border-radius: var(--corner-radius-radius-12-41-72-wxh, 16px);\n    /* Create gradient border effect - Gold to Pink/Purple */\n    background: \n        linear-gradient(109deg, #3C2929 0%, #161B20 100%) padding-box,\n        linear-gradient(90deg, #FFD976 0%, #FD82F8 100%) border-box;\n    border: 1px solid transparent;\n}\n\n.priceCard:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(253, 130, 248, 0.3);\n}\n\n.priceCard:active {\n    transform: translateY(0);\n}\n\n.priceCardSelected {\n    background: \n        linear-gradient(109deg, #3C2929 0%, #161B20 100%) padding-box,\n        linear-gradient(90deg, #FFD976 0%, #FD82F8 100%) border-box;\n    border: 2px solid transparent;\n    box-shadow: 0 0 20px rgba(253, 130, 248, 0.5);\n}\n\n.priceCardContent {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    width: 100%;\n}\n\n/* Price Row */\n.priceRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.priceGroup {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.currentPrice {\n    font-family: 'Noto Sans', sans-serif;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 24px;\n    background: var(--ui-gradient-studio-brand, linear-gradient(270deg, #FD82F8 0%, #FFD976 100%));\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.originalPrice {\n    font-family: 'Noto Sans', sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #9396A3;\n    text-decoration: line-through;\n    text-decoration-skip-ink: none;\n}\n\n.perDayBadge {\n    background-color: #0D0E11;\n    border-radius: 4px;\n    padding: 4px 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.perDayText {\n    font-family: 'Noto Sans', sans-serif;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 14px;\n    background: linear-gradient(180deg, #D5982F 0%, #FDF59A 50%, #D5982F 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    white-space: nowrap;\n}\n\n/* Duration Row */\n.durationRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.durationText {\n    font-family: 'Noto Sans', sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #F3F4F6;\n    white-space: nowrap;\n}\n\n.badgeIconWrapper {\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n}\n\n.badgeIcon {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n/* Timeline Section */\n.timelineSection {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    align-items: center;\n    padding: 0 20px;\n    border-radius: 16px;\n    width: 100%;\n    box-sizing: border-box;\n    flex-shrink: 0;\n}\n\n.timelineContent {\n    display: flex;\n    gap: 8px;\n    align-items: flex-start;\n    width: 100%;\n    flex-shrink: 0;\n}\n\n/* Vertical Line SVG Container */\n.verticalLine {\n    position: relative;\n    width: 7px;\n    height: 52px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.verticalLine svg {\n    display: block;\n    width: 100%;\n    height: 100%;\n}\n\n/* Dates Container */\n.datesContainer {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    gap: 12px;\n    min-width: 0;\n    flex-shrink: 0;\n}\n\n.dateRow {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    width: 100%;\n    font-family: 'Noto Sans', sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.dateLabel {\n    color: #9396A3;\n    white-space: nowrap;\n}\n\n.dateValue {\n    color: #F3F4F6;\n    white-space: nowrap;\n}\n\n/* Separator */\n.separator {\n    width: 100%;\n    height: 1px;\n    background: linear-gradient(90deg, \n        rgba(255, 255, 255, 0) 0%, \n        rgba(255, 255, 255, 0.2) 50%, \n        rgba(255, 255, 255, 0) 100%\n    );\n    flex-shrink: 0;\n}\n\n/* Footer Text */\n.footerText {\n    font-family: 'Noto Sans', sans-serif;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #9396A3;\n    text-align: center;\n    width: 100%;\n    margin: 0;\n    flex-shrink: 0;\n    white-space: pre-wrap;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .timelineSection {\n        padding: 0 16px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `plansScreen_container__ljbWx`,
	"logoContainer": `plansScreen_logoContainer__rBIPW`,
	"logo": `plansScreen_logo__9zZus`,
	"contentSection": `plansScreen_contentSection__lwbV-`,
	"title": `plansScreen_title__wCWEn`,
	"plansContainer": `plansScreen_plansContainer__LR1H0`,
	"priceCard": `plansScreen_priceCard__cFsj7`,
	"priceCardSelected": `plansScreen_priceCardSelected__0gY4P`,
	"priceCardContent": `plansScreen_priceCardContent__2QkCX`,
	"priceRow": `plansScreen_priceRow__pH-lX`,
	"priceGroup": `plansScreen_priceGroup__0paUl`,
	"currentPrice": `plansScreen_currentPrice__zsKwn`,
	"originalPrice": `plansScreen_originalPrice__Vq2l1`,
	"perDayBadge": `plansScreen_perDayBadge__GFRi1`,
	"perDayText": `plansScreen_perDayText__1yvRq`,
	"durationRow": `plansScreen_durationRow__MDdGR`,
	"durationText": `plansScreen_durationText__WDNJu`,
	"badgeIconWrapper": `plansScreen_badgeIconWrapper__8Onra`,
	"badgeIcon": `plansScreen_badgeIcon__CYz-0`,
	"timelineSection": `plansScreen_timelineSection__v2NoZ`,
	"timelineContent": `plansScreen_timelineContent__IzVsQ`,
	"verticalLine": `plansScreen_verticalLine__6do8F`,
	"datesContainer": `plansScreen_datesContainer__NsN8h`,
	"dateRow": `plansScreen_dateRow__SB9cc`,
	"dateLabel": `plansScreen_dateLabel__QpaxS`,
	"dateValue": `plansScreen_dateValue__dT5N3`,
	"separator": `plansScreen_separator__4f4RJ`,
	"footerText": `plansScreen_footerText__S6xUr`
};
export default ___CSS_LOADER_EXPORT___;
